import { render, staticRenderFns } from "./AbnSection.vue?vue&type=template&id=478584be&scoped=true&"
import script from "./AbnSection.vue?vue&type=script&lang=js&"
export * from "./AbnSection.vue?vue&type=script&lang=js&"
import style0 from "./AbnSection.vue?vue&type=style&index=0&id=478584be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478584be",
  null
  
)

export default component.exports